(function ($) {
  const DEBUG_GA_FIRE_EVENT = false;

  function fireEvent(eventName) {
    if (!eventName) {
      return;
    }

    if (DEBUG_GA_FIRE_EVENT && window.console && typeof window.console.debug === 'function') {
      console.debug('[GA fireEvent]', eventName);
    }

    if (typeof window.gtag === 'function') {
      gtag('event', eventName);
    }
  }

  function fireEventWithParams(eventName, params) {
    if (!eventName) {
      return;
    }

    if (DEBUG_GA_FIRE_EVENT && window.console && typeof window.console.debug === 'function') {
      console.debug('[GA fireEvent]', eventName);
    }

    if (typeof window.gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  function bindSoundPageEvents() {
    let skipNextMainPlayerPlayEvent = false;

    function getPageLabel(pageTitle) {
      switch ((pageTitle || '').toLowerCase()) {
        case 'dj':
          return 'DJ Page';
        case 'live at 214':
          return 'Live at 214';
        case '':
          return 'Page';
        default:
          return pageTitle + ' Page';
      }
    }

    const dj = $('#shopify-section-page-store-2 .section-stores__item:first-child .store-link');
    const liveAt214 = $('#shopify-section-page-store-2 .section-stores__item:nth-child(2) .store-link');

    if (dj.length) {
      dj.on('click', function () {
        
        fireEvent('Sound_DJ Page');
      });
    }

    if (liveAt214.length) {
      liveAt214.on('click', function () {
        
        fireEvent('Sound_Live at 214 Page');
      });
    }

    $(document).on('click', '.video-box', function () {
      const videoBox = $(this);

      if (videoBox.hasClass('video-box--coming-soon')) {
        return;
      }

      const pageTitle = videoBox.closest('[data-page-title]').attr('data-page-title') || '';
      const pageEventPrefix = 'Sound_' + getPageLabel(pageTitle);

      const performer = videoBox.find('.video-box__artist-name').first().text();
      const location = videoBox.find('.video-box__artist-location').first().text();
      const date = videoBox.find('.video-box__date').first().text();
      const vidid = videoBox.find('.video-box__play').first().data('vidid');

      if (vidid) {
        skipNextMainPlayerPlayEvent = true;
      }

      
      
      fireEvent([pageEventPrefix, performer, location, date].join('_'));
    });

    $(document).on('sound:main-player-play', function () {
      if (skipNextMainPlayerPlayEvent) {
        skipNextMainPlayerPlayEvent = false;
        return;
      }

      const pageTitle = $('[data-page-title]').first().attr('data-page-title') || '';
      const pageEventPrefix = 'Sound_' + getPageLabel(pageTitle);
      const mainArtistText = $('#main-artist').first().text();
      const mainArtistParts = mainArtistText.split(',');
      const performer = (mainArtistParts[0] || '').trim();
      const location = (mainArtistParts.slice(1).join(',') || '').trim();
      const date = $('#main-date').first().text();

      
      
      fireEvent([pageEventPrefix, performer, location, date].join('_'));
    });

    $(document).on('change', '.toggle-input', function () {
      const pageTitle = $(this).closest('[data-page-title]').attr('data-page-title')
        || $('[data-page-title]').first().attr('data-page-title')
        || '';
      const mode = $(this).is(':checked') ? 'Night Mode' : 'Day Mode';

      
      
      fireEvent(['Sound_' + getPageLabel(pageTitle), mode].join('_'));
    });

    $(document).on('click', '.category-menu-link', function () {
      
      fireEvent('Sound_Breadcrumb Main Page');
    });
  }

  function bindNavigationMenuEvents() {
    const eventName = 'navigation_click';

    const menuToggle = $('.menu-toggle');
    const closeMenu = $('.close-menu-toggle');
    const shopMenuItem = $('.header .nav .main-nav > li').eq(0).find('a');
    const exploreMenuItem = $('.header .nav .main-nav > li').eq(1).find('a');
    const linkWithinMenu = $('.header .nav .nav__container a');

    let params = {};

    menuToggle.on('click', function() {
      params.ui_section = 'navigation';
      params.ui_action = 'expand';

      var path = window.location.pathname;
      var segs = path.split('/').filter(Boolean);
      var first = (segs[0] || '').toLowerCase();
     
      var type;
      if (segs.length === 0)            type = 'home';
      else if (first === 'cart')        type = 'cart';
      else if (first === 'products')    type = 'product';
      else if (first === 'collections') {
        // /collections/<handle>/products/<product> is still a product page
        type = (segs[2] && segs[2].toLowerCase() === 'products') ? 'product' : 'collection';
      }
      else if (first === 'blogs')       type = 'blog';
      else if (first === 'pages')       type = 'page';
      else                              type = first || 'unknown';
     
      // Title: prefer og:title, fall back to <title>, strip the " - Aimé Leon Dore" suffix
      var og = document.querySelector('meta[property="og:title"]');
      var title = (og && og.content) || document.title || '';
      title = title.replace(/\s*[|\u2013\u2014-]\s*Aim[eé]\s*Leon\s*Dore\s*$/i, '').trim();
      title = title.replace(' at AimeLeonDore.com', '').trim();
     
      if (type === 'home') title = title || 'Home';
      if (type === 'cart') title = title || 'Cart';

      params.ui_label = type + '_' + title;

      fireEventWithParams(eventName, params)
    });

    closeMenu.on('click', function() {
      params.ui_section = 'navigation';
      params.ui_action = 'close';
      fireEventWithParams(eventName, params)
    });

    shopMenuItem.on('click', function() {
      params.ui_section = 'navigation_shop';
      fireEventWithParams(eventName, params)
    });

    exploreMenuItem.on('click', function() {
      params.ui_section = 'navigation_explore';
      fireEventWithParams(eventName, params)
    });

    linkWithinMenu.on('click', function() {
      params.ui_section = 'navigation';
      params.ui_label = $(this).text();
      fireEventWithParams(eventName, params)
    });

    $('body, #main-content').on('click', function(e) {
      if($('body').hasClass('menu-collapse')) {
        if(!$(e.target).hasClass('search-close')) {
          if (!$(e.target).closest('.nav.nav-collapse').length) {
            $('.close-menu-toggle').trigger('click');
          }
        }
      }
    })
  }

  function bindProductCarouselEvents() {
    if($(window).width() < 1025) {
      productCarousel.forEach(swiper => {
          swiper.on('slideChange', function () {
              const eventName = 'image_swipe';
              let params = {};
              params.item_category = $('#producttype').val();
              params.swipe_direction = this.swipeDirection;
              params.item_id = $('#prodid').val();
              params.item_color = $('.product__variants--colors select').val();
              fireEventWithParams(eventName, params)
          });
      });
    }
  }

  function bindPlpCarouselEvents() {
    const carouselSelector = '.products-collection .plp-carousel';

    function firePlpImageSwipe(carousel) {
      if (typeof window.gtag !== 'function') {
        return;
      }

      const carouselOffset = carousel.offset().left;
      const carouselWidth = carousel.outerWidth();
      const carouselCenter = carouselOffset + carouselWidth / 2;

      let closestImgIndex = -1;
      let closestImgDistance = Infinity;

      carousel.find('img').each(function (index) {
        const img = $(this);
        const imgOffset = img.offset().left;
        const imgWidth = img.outerWidth();
        const imgCenter = imgOffset + imgWidth / 2;
        const distance = Math.abs(imgCenter - carouselCenter);

        if (distance < closestImgDistance) {
          closestImgDistance = distance;
          closestImgIndex = index;
        }
      });

      if (closestImgIndex < 0) {
        return;
      }

      const imagePosition = closestImgIndex + 1;
      const previousPosition = carousel.data('gaImgPosition') || 1;

      // Only report when the visible image actually changed.
      if (imagePosition === previousPosition) {
        return;
      }

      carousel.data('gaImgPosition', imagePosition);

      const product = carousel.parents('.plp-product').first();
      let params = {};
      params.item_category = $('.category-menu-toggle').text().trim();
      params.swipe_direction = imagePosition > previousPosition ? 'next' : 'prev';
      params.image_swipe = imagePosition;
      params.item_id = product.data('product-id');
      params.item_color = product.data('color');
      fireEventWithParams('image_swipe', params);
    }

    // Mobile swipe. Delay lets the scroll-snap settle before measuring.
    $('body').on('touchend', carouselSelector, function () {
      const carousel = $(this);
      setTimeout(function () {
        firePlpImageSwipe(carousel);
      }, 500);
    });

    // Desktop drag. Delay lets the snap animation finish before measuring.
    $('body').on('mouseup mouseleave', carouselSelector, function () {
      const carousel = $(this);
      setTimeout(function () {
        firePlpImageSwipe(carousel);
      }, 350);
    });
  }

  function bindQuickcartMobileEvents() {
    if($(window).width() < 1025) {
      $('#CartModalMobile .cart-modal__close').on('click', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Close';
        params.device_type = 'm';
        fireEventWithParams(eventName, params)
      });

      $('#mobile-quickcart-view-cart').on('click', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'View Cart';
        params.device_type = 'm';
        fireEventWithParams(eventName, params)
      });

      $('#CartModalMobile .cart-buttons .btn--dark').on('click', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Checkout';
        params.device_type = 'm';
        fireEventWithParams(eventName, params)
      });

      $('.cart-modal__overlay').on('click', function() {
        if($('body').hasClass('cart-modal-visible') && $('#CartModalMobile').hasClass('cart-modal--collapse')) {
          const eventName = 'quickcart_click';
          let params = {};
          params.ui_action = 'Close';
          params.device_type = 'm';
          fireEventWithParams(eventName, params)
        }
      });
    }
  }

  function bindQuickcartDesktopEvents() {
    if($(window).width() >= 1025) {
      $('#CartModal .cart-modal__close').on('click', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Close';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart-modal__view-cart-btn', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'View Cart';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart-buttons .btn--dark', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Checkout';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart-buttons .btn-update', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Update';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart-item-increase', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Unit Increase';
        params.amount = '1';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart-item-decrease', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Unit Decrease';
        params.amount = '1';
        fireEventWithParams(eventName, params)
      });

      $('body').on('click', '#CartModal .cart__remove', function() {
        const eventName = 'quickcart_click';
        let params = {};
        params.ui_action = 'Remove';
        fireEventWithParams(eventName, params)
      });

      $('.cart-modal__overlay').on('click', function() {
        if($('body').hasClass('cart-modal-visible') && $('#CartModal').hasClass('cart-modal--collapse')) {
          const eventName = 'quickcart_click';
          let params = {};
          params.ui_action = 'Close';
          fireEventWithParams(eventName, params)
        }
      });
    }
  }

  window.gaTagging = {
    bindSoundPageEvents: bindSoundPageEvents,
  };

  $(function () {
    if ($('#shopify-section-page-store-2').length || $('[data-page-title]').length) {
      bindSoundPageEvents();
    }

    bindNavigationMenuEvents();
    if($('body').hasClass('template-product')) {
      setTimeout(function() {
        bindProductCarouselEvents();
      }, 2000);
    }
    if($('.products-collection').length) {
      bindPlpCarouselEvents();
    }
    bindQuickcartMobileEvents();
    bindQuickcartDesktopEvents();
  });
})(jQuery);
